import { FormikValues, FormikErrors } from 'formik';
import { HospitalBase } from '../../../Data/Hospital';
import { dictionary } from '../../../dictionary';
import { FormFieldDescriptor } from '../../../Shared/fields/formTypes';
import { createDescriptor } from '../../../Utils/formik.utils';
import { validateCharacterLimit, validateRequiredFields } from '../../../Utils/validationUtils';

export interface DepartmentFormFields {
  name: string;
  hospitals: HospitalBase[];
}

export const departmentFormFields: Record<keyof DepartmentFormFields, FormFieldDescriptor> = {
  name: createDescriptor({ name: 'name', label: dictionary.DEPARTMENT_FORM_NAME, required: true }),
  hospitals: createDescriptor({ name: 'hospitals', label: dictionary.DEPARTMENT_FORM_HOSPITAL, required: true, inputFormat: 'multi-select' }),
};

export const validateCreateDepartmentForm = async (values: FormikValues): Promise<FormikErrors<FormikValues>> => {
  const { name } = departmentFormFields;

  return {
    ...validateCharacterLimit(values, [name], 255),
    ...validateRequiredFields(values, Object.values(departmentFormFields)),
  };
};

export const validateEditDepartmentForm = async (values: FormikValues): Promise<FormikErrors<FormikValues>> => {
  const { name } = departmentFormFields;

  return {
    ...validateCharacterLimit(values, [name], 255),
    ...validateRequiredFields(values, [name]),
  };
};
